import Layout from "../components/layout"
import Spacer from "../components/spacer"
import Introduction from "../components/introduction"
import FeaturedMedia from "../components/featuredMedia"
import ChallengeSolution from "../components/challengeSolution"
import SmallCaption from "../components/smallCaption"
import MoreProjects from "../components/moreProjects"
import NextItem from "../components/nextItem"
import Testimonial from "../components/testimonial"
import Gallery from "../components/gallery"
import Title from "../components/title"
import Stats from "../components/stats"
import Seo from "../components/seo"
import { graphql } from 'gatsby'
import React from 'react'

export default function Projects({ data }) {
  console.log(data.project.galleryAssets.length)
  return (
    <Layout>
      <Seo title={data.project.name} />
      <Spacer />
      <Spacer className='m-hide' />
      <div className="ma">
        <Title className='sm' text={data.project.name} />
      </div>
      <Spacer className='m-hide' />
      <Spacer />
      {(data.project.featureCaption ? <SmallCaption text={data.project.featureCaption} /> : '')}
      <FeaturedMedia image={data.project.featuredImage?.gatsbyImageData} color={data.project.projectColor} video={data.project.featuredVideo} title={data.project.name} ratio={data.project.featuredRatio} />
      <Spacer className='m-hide' />
      {(data.project.introductionText ?
        <>
          <Spacer className='m-hide' />
          <Introduction project={data.project} />
          <Spacer />
          <Spacer className='m-hide' />
        </>
        : '')}
      {(data.project.galleryAssets.length > 0 ?
        <>
          <Gallery assets={data.project.galleryAssets} thumbnails={data.project.thumbnails} color={data.project.projectColor} />
          <Spacer className='m-hide' />
        </>
        : '')}
      {(data.project.challengeSolution.length > 0 ?
        <>
          test
          <ChallengeSolution challenges={data.project.challengeSolution} />
          <Spacer className='m-hide' />
        </>
        : '')}
      {(data.project.testimonial ?
        <>
          <Testimonial image={data.project.testimonialImage} testimonial={data.project.testimonial} author={data.project.testimonialAuthor} />
          <Spacer />
        </>
        : '')}
      {(data.project.statisticFigure.length > 0 ?
        <>
          <Stats stats={data.project.statisticFigure} />
          <Spacer />
        </>
        : '')}
      <MoreProjects projects={data.moreProjects.edges} />
      <Spacer className='m-hide' />
      <Spacer className='m-hide' />
      <NextItem items={data.allProjects.edges} />
    </Layout>
  )
}


export const query = graphql`
    query Project($id: String,$catId:String ){
      project:datoCmsProject(id:{eq:$id}){
        id
        name
        slug
        introductionText
        featureCaption 
        featuredVideo
        featuredRatio
        testimonial
        websiteLink
        testimonialAuthor
        testimonialImage {
          gatsbyImageData(placeholder:NONE)
        }
        projectColor {
          hex
        }
        featuredImage {
          gatsbyImageData(placeholder:NONE)
        }
        details {
          title
          details
        }
        statisticFigure {
          title
          figure
        }
        challengeSolution {
          solutionContent
          solutionOverline
          challengeOverline
          challengeTitle
        }
        galleryAssets {
          videoLink
          assetRatio
          imageAsset {
            gatsbyImageData(placeholder:NONE)
          }
        }
        thumbnails:galleryAssets {
          videoLink
          assetRatio
          imageAsset {
            gatsbyImageData(placeholder:NONE, layout: CONSTRAINED, width: 400)
          }
        }
        statisticFigure {
          title
          figure
        } 
      }
      moreProjects:allDatoCmsProject(limit: 4, filter: {id: {ne: $id},  category:{elemMatch: {id: {eq:$catId } } } }) { 
        edges {
          node {
            name
            year
            slug
            scope
            projectColor {
              hex
            }
            category {
              id
              name
            }
            featuredVideo
            featuredImage {
              gatsbyImageData(placeholder:NONE, layout: CONSTRAINED, width: 1200)
            }
          }
        }
      }
      allProjects:allDatoCmsProject(filter: {id: {ne: $id},featuredVideo: {eq: ""}}) { 
        edges {
          node {
            featuredVideo
            featuredImage {
              gatsbyImageData(placeholder:NONE, layout: CONSTRAINED, width: 400)
            }
          }
        } 
      }
    }
    fragment ProjectThumbnail on DatoCmsProject{
      id
      name
      slug
    }
`